import { registerFormInputComponent } from "@vendure/admin-ui/core";
import { CategorySeoCategorySelectComponent } from "./components/category-seo-category-select/category-seo-category-select.component";

export default [
  registerFormInputComponent(
    "category-seo-category-select",
    CategorySeoCategorySelectComponent,
  ),
];
